import { useProfileStore } from "~/store/profileStore";
import { UserRole } from "~/types/user";

interface User {
  id: string | null;
  name: string | null;
  lastname: string | null;
  email: string | null;
  role: UserRole | null;
}

export function useCurrentUser() {
  const { id, name, lastname, email, role } = useProfileStore();

  const user: User = {
    id,
    name,
    lastname,
    email,
    role,
  };

  const isAdmin = role === "superadmin";
  const isSeller = role === "seller";
  const isPayments = role === "cobranza";
  const isOperations = role === "logistica";
  const isRisk = role === "risk";
  const isTransportista = role === "transportista";
  const isProduction = role === "production";

  return {
    user,
    isAdmin,
    isSeller,
    isPayments,
    isOperations,
    isRisk,
    isTransportista,
    isProduction,
  };
}
